import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import LightBox from '@bd/bdui-lightbox';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
import numeral from 'numeral';
import PlatmapModal from './PlatmapModal';
import { colors, typography } from '../../styles';

const styles = css`

  .Banner_Wrapper {
    margin:80px auto;

  }
  .Banner_Result {
    color:  ${colors.color5};
    font:400 16x/1 ${typography.SansSerif};
    padding:20px;
    border-top:1px solid ${colors.color1};
    background: white;
    background-color: ${colors.color2};
    @media (min-width: 768px) {
    }
  }
  .Banner_Result:nth-child(even) {
    background-color:  ${colors.color2Light};
  }
  .Banner_Result:last-child {
    border-bottom:1px solid ${colors.color1};
  }
  .Banner_Content {
    display: flex;
    flex-flow:row wrap;
  }
  .linkLike {
    color:  ${colors.color1};
    cursor:pointer;
    transition: all .25s ease;
  }
  .linkLike:hover {
    color:  ${colors.color1Darkest};
    cursor:pointer;
  }
  .Lot_Price {
    font:700 20px/1 ${typography.SansSerif};
  }
`;

function HomesResults({ lots, sort }) {
  const filteredLots = lots.filter(lot => lot.price && lot.price > 10000);
  return (
    <div className={styles}>
      <div className="container Banner_Wrapper">
        {
          orderBy(filteredLots, sort.field, get(sort, 'dir', 'asc')).map(lot => (
            <div key={lot._id} className="Banner_Result row">
              <div className="col-6">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <div>
                      <strong>{get(lot, 'address.streetAddress')}</strong>
                    </div>
                    <div>
                      <strong>{`${get(lot, 'address.addressLocality')}, ${get(lot, 'address.addressRegion')}`}</strong>
                    </div>
                    <div>
                      Lot #{get(lot, 'lot')}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    {numeral(get(lot, 'lotSize') / 43560).format('0.0')} Acres
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-12 col-md-6 order-md-2">
                    <strong className="Lot_Price">{numeral(get(lot, 'price')).format('$0,0')}</strong>
                  </div>
                  <div className="col-12 col-md-6">
                    {get(lot, 'status')}
                    <div>
                      <strong><a href={GoogleMapUrl(lot)} target="_blank" rel="noopener noreferrer"><img src="/images/icon-pin.svg" alt="" width="20" height="20" /> Google Map</a></strong>
                    </div>
                    <div>
                      <PlatmapModal home={lot}>
                        <strong className="linkLike" role="button" tabIndex="0"><img src="/images/icon-lots.svg" alt="" width="20" height="20" /> View Plat Map</strong>
                      </PlatmapModal>
                    </div>
                    <div>
                      {
                        get(lot, 'photos').length > 0 &&
                          <LightBox
                            items={get(lot, 'photos', [])}
                            button={(
                              <strong className="linkLike"><img src="/images/icon-camera.svg" alt="" width="20" height="20" /> View Photos</strong>
                            )}
                          />
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}

HomesResults.propTypes = {
  lots: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
};

export default withData(
  {
    lots: true,
  },
)(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/Lots/LotsResults.js